import "./style.css";
import React  from "react";
import { Modal, Button } from "react-bootstrap";

const ModalSmall = ({
  showModal,
  setShowModal,
  title,
  text,
  type,
}: {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  text: string;
  type: string;
}) => {
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} animation={false} className={type}>
        <Modal.Header className="modalHeader">
        <Modal.Title className="modalTitle" id="modal-alert">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">{text}</Modal.Body>
          <Button variant="primary" onClick={() => setShowModal(false)}>
            OK
          </Button>
      </Modal>
  );
}; 
export default ModalSmall;
